import { createApiClient, fetchTransport } from '@daoyouxueba/api-client'

// Every request names the client, so the server can write it into the learning event log (practice.md, common section).
export const CLIENT_SURFACE = 'web'
export const CLIENT_VERSION = '2026.11.0'

export const api = createApiClient(fetchTransport('', { 'X-Client-Surface': CLIENT_SURFACE, 'X-Client-Version': CLIENT_VERSION }))
export { ApiError, newAttemptId } from '@daoyouxueba/api-client'
export type * from '@daoyouxueba/api-client'
